var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnNavi24 = function SvgLightIcnNavi24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.525 13.144c.633-.616.633-1.64.005-2.283l-9.386-9.386a1.617 1.617 0 0 0-2.289 0l-9.38 9.38a1.617 1.617 0 0 0 0 2.29l9.38 9.38a1.617 1.617 0 0 0 2.289 0zm-10.276.305a.05.05 0 0 1 .05.05v2.926a.05.05 0 0 0 .083.037l4.899-4.444a.05.05 0 0 0 0-.074L12.381 7.5a.05.05 0 0 0-.083.037v2.924a.05.05 0 0 1-.05.05H7.584a.05.05 0 0 0-.05.05V13.4c0 .028.022.05.05.05z",
    clipRule: "evenodd"
  })));
};
export default SvgLightIcnNavi24;